// extracted by mini-css-extract-plugin
export default {"wrapperCard":"styles_wrapperCard__Z-Z1V","titleCard":"styles_titleCard__5mO9Y","bordered":"styles_bordered__fYoIJ"};